import React from 'react';

export default class TruncateLine extends React.Component {
  truncateMiddle = ({ text = '', charsbefore }) => {
    if (text.length < charsbefore)
      return text;

    const division = charsbefore / 2;

    const before = text.substring(0, division);

    const after = text.substring(text.length - division, text.length);

    return `${before}...${after}`;
  };

  truncateEnd = ({ text = '', charsbefore }) => {
    const before = text.substring(0, charsbefore);

    return `${before}...`;
  };
  render() {
    const {
      charsbefore,
      position,
    } = this.props;

    let text = this.props.children;

    switch (position) {
      case 'middle':
        text = this.truncateMiddle({text, charsbefore});
        break;
      case 'end':
        text = this.truncateEnd({text, charsbefore});
    }

    return (
      <p {...this.props}>
        {text}
      </p>
    )
  }
};

TruncateLine.defaultProps = {
  position: 'middle',
  charsbefore: 25,
  charsafter: 12,
};
